<template>
  <div class="elective-view">
    <div class="tab">
      <router-link to="/searchIndex/mainSearch/elective/eleresources">
        <div :class="{ cur: isActive }" @click="isActive = 1">
          {{ $t("search.studyResources") }}
        </div>
      </router-link>
      <router-link to="/searchIndex/mainSearch/elective/eleplan">
        <div :class="{ cur: !isActive }" @click="isActive = 0">
          {{ $t("search.trainPlan") }}
        </div>
      </router-link>
    </div>
    <div class="list">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: "elective",
  data() {
    return {
      isActive: 1,
    };
  },
};
</script>
<style lang="less" scoped>
.elective-view {
  display: flex;
  flex-direction: column;
  font-size: 0.24rem;
  .tab {
    height: 7vh;
    padding: 0.2rem 0.3rem 0;
    box-sizing: border-box;
    background: #eeeeee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      width: 3.36rem;
      border: 1px solid #005587;
      color: #005587;
      line-height: 0.58rem;
      text-align: center;
      border-radius: 0.6rem;
      &.cur {
        background: #005587;
        color: #ffffff;
      }
    }
  }
  .list {
    height: 82vh;
    overflow: auto;
  }
}
</style>
